/* eslint-disable react/jsx-one-expression-per-line */
import React from "react";
import image from "components/Images/error-500.svg";

const Error500 = () => {
  return (
    <div className="error">
      <div className="error__container">
        <img
          className="error__image"
          src={image}
          alt="simple illustration of a broken foot"
        />
        <div className="error__message">
          <h1>Looks like something is broken.</h1>
          <p>
            Please try again later or{" "}
            <a href="mailto:customer.service@healthstream.com.">contact us</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Error500;
